import React, { useContext, useEffect, useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import Select from 'react-select';

import {
    CardCorteTec,
    ChangeConfirmation,
    Confirmation,
    LoadinSpin,
    ModChangeAgentePay,
    PageTitle,
    Table,
} from '../../components';
import { Badge, Button, Card, Col, Form, OverlayTrigger, Row, Tooltip } from 'react-bootstrap';
import { headTbl } from '../../data/tables';

import { checkAccess } from '../../helpers/details';
import { AuthContext } from '../../auth/AuthContext';
import { UserContext } from '../../context/user/ContextUser';
import { fetchConToken } from '../../api/fetch';
import ModEditCorte from '../../components/finanzas/ModEditCorte';
import Pdfgenerate from '../../components/finanzas/Pdfgenerate';

const CortesTecnicos = () => {
    const { usersState } = useContext(UserContext);
    const [id, setId] = useState('');
    const [load, setLoad] = useState(false);
    const [data, setData] = useState(null);
    const [item, setItem] = useState(null);
    const [destroy, setDestroy] = useState({});
    console.log('********:', data);
    useEffect(() => {
        setLoad(true);
        getData();
    }, [id]);

    const getData = async () => {
        if (!id) {
            setLoad(false);
            return;
        }

        const resp = await fetchConToken(`factura/cortetec/${id}`);
        if (resp.ok) setData(resp.data);
        setLoad(false);
    };

    const { auth } = useContext(AuthContext);
    const permisos = checkAccess('Corte de técnicos', auth.accesos);
    const navigate = useNavigate();
    if (!permisos.access) navigate(`/`);

    const [show, setShow] = useState(false);
    const [showt, setShowt] = useState(false);
    const [showd, setShowd] = useState(false);
    const [showE, setShowE] = useState(false);

    const [info, setInfo] = useState({});
    const showDone = () => {
        setInfo({
            data: { id },
            endpoint: `apptec/cortedone/${id}`,
            head: 'Pagar corte',
            body: `El corte del tecnico  pasara a pagado`,
        });
        setShow(true);
    };

    const ItemsC = ({ row }) => {
        let items = [];

        try {
            const parsed = JSON.parse(row.original.items);
            if (Array.isArray(parsed)) {
                items = parsed;
            } else {
                console.warn('Items no es un array:', parsed);
            }
        } catch (error) {
            console.error('Error al parsear items:', error);
        }
        if (!Array.isArray(items) || items.length === 0) {
            return <span className="text-muted">Sin datos</span>;
        }

        return (
            <div>
                {items.map((pt, i) => (
                    <Col xs={1} key={i + 'napsy'}>
                        <span className={`badge bg-light text-dark ms-1 fs-6`}>
                            {pt.type} ${pt.monto}
                        </span>
                    </Col>
                ))}
            </div>
        );
    };
    const ItemsLOGS = ({ row }) => {
        let items = [];

        try {
            const parsed = JSON.parse(row.original.logs);
            if (Array.isArray(parsed)) {
                items = parsed;
            } else {
                console.warn('Items no es un array:', parsed);
            }
        } catch (error) {
            console.error('Error al parsear items:', error);
        }
        if (!Array.isArray(items) || items.length === 0) {
            return <span className="text-muted">Sin cambios</span>;
        }

        return (
            <div className="">
                {items.map((pt, i) => (
                    <div key={i + 'log'} className="d-flex align-items-start mb-2 px-1 rounded shadow-sm bg-light">
                        {/* Punto del timeline */}
                        <div className="me-3 mt-1 rounded-circle bg-primary" style={{ width: 10, height: 10 }} />

                        {/* Contenido */}
                        <div>
                            <div className="fw-semibold text-dark" style={{ fontSize: 12 }}>
                                {pt.mensaje}
                            </div>
                            <small className="text-muted">{pt.fecha}</small>
                        </div>
                    </div>
                ))}
            </div>
        );
    };

    const deleteItem = (item) => {
        setDestroy({ ...item, type: 'CORTE' });
        setShowd(true);
    };
    const edititem = (item) => {
        setItem(item);
        setShowE(true);
    };
    const ActionColumn = ({ row }) => {
        return (
            <>
                {/* <OverlayTrigger placement="left" overlay={<Tooltip id="overlay-edit">Editar</Tooltip>}>
                    <i className="mdi mdi-pencil-box mdi-18px text-info " onClick={() => edititem(row.original)}></i>
                </OverlayTrigger> */}
                <OverlayTrigger placement="left" overlay={<Tooltip id="overlay-eliminard">Eliminar</Tooltip>}>
                    <i
                        className="mdi mdi-delete-alert text-danger mdi-18px "
                        onClick={() => deleteItem(row.original)}></i>
                </OverlayTrigger>
                {/* <OverlayTrigger placement="left" overlay={<Tooltip id="overlay-eliminard">Transferir pago</Tooltip>}>
                    <i
                        className="mdi mdi-account-arrow-right mdi-18px text-warning "
                        onClick={() => {
                            setShowt(true);
                            setItem(row.original);
                        }}></i>
                </OverlayTrigger> */}
            </>
        );
    };
    const columns = [
        {
            Header: 'Cliente',
            accessor: 'nombre',
            sort: true,
            Cell: ({ row }) => (
                <NavLink to={`/admin/viewuser/${btoa(`${row.original?.idus}`)}`} className="pointer">
                    {row.original.nombre}
                </NavLink>
            ),
        },
        {
            Header: 'Monto',
            accessor: 'monto',
            sort: true,
            Cell: ({ value }) => <>${value}</>,
        },
        {
            Header: 'Estado',
            accessor: 'estado',
            sort: true,
            Cell: ({ value }) => (
                <Badge bg={`${value == 0 ? 'danger' : 'SUCCESS'}`}>{value == 0 ? 'PENDIENTE' : 'PAGADO'}</Badge>
            ),
        },
        {
            Header: 'Fecha',
            accessor: 'fecha',
            sort: true,
        },
        {
            Header: 'Desglose',
            accessor: 'items',
            sort: true,
            Cell: ItemsC,
        },
        {
            Header: 'Cambios',
            accessor: 'logs',
            sort: true,
            Cell: ItemsLOGS,
        },

        {
            Header: 'Id factura',
            accessor: 'idf',
            sort: true,
        },
        {
            Header: 'Tipo',
            accessor: 'tipo',
            sort: true,
            Cell: ({ value }) => {
                let bgColor;

                switch (value) {
                    case 'INSTALACIÓN':
                        bgColor = 'info';
                        break;
                    case 'TICKET':
                        bgColor = 'primary';
                        break;
                    default:
                        bgColor = 'dark';
                }

                return <Badge bg={bgColor}>{value}</Badge>;
            },
        },

        {
            Header: 'Acción',
            accessor: 'action',
            sort: false,
            classes: 'table-action',
            Cell: ActionColumn,
        },
    ];
    const sizePerPageList = headTbl(data?.corte.length);
    if (load) return <LoadinSpin />;
    return (
        <div>
            <PageTitle
                breadCrumbItems={[
                    { label: 'Finanzas', path: '/finanzas' },
                    { label: 'Cortes de tecnicos', path: '/admin/cortes', active: true },
                ]}
                title={'Cortes de tecnicos'}
            />
            <Card>
                <Card.Body>
                    {/* <Pdfgenerate /> */}
                    <div className="d-flex justify-content-center">
                        <Col sm={5}>
                            <Form.Group className="mb-3" controlId="validationCustom19">
                                <Form.Label>Buscar corte de Agente</Form.Label>
                                <Form.Select value={id} name="tipo" required onChange={(e) => setId(e.target.value)}>
                                    <option value="">--SELECCIONAR AGENTE--</option>
                                    {usersState.agentes
                                        .filter((agente) => agente.campo === true) // <- Aquí filtras solo los "done"
                                        .map((agente) => (
                                            <option key={agente.id_agent} value={agente.id_agent}>
                                                {agente.name}
                                            </option>
                                        ))}
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        {id && (
                            <Col sm="2" className="mt-3">
                                <Button size="lg" variant="primary" onClick={() => showDone()}>
                                    Entregado <i className="mdi mdi-cash-check   "></i>
                                </Button>
                            </Col>
                        )}
                    </div>

                    <Col>
                        {data ? (
                            <>
                                <CardCorteTec data={data} />{' '}
                                <Table
                                    columns={columns}
                                    data={data.corte}
                                    pageSize={25}
                                    sizePerPageList={sizePerPageList}
                                    isSortable={true}
                                    pagination={true}
                                    isSearchable={true}
                                    searchBoxClass="mb-2"
                                />
                            </>
                        ) : null}
                    </Col>
                </Card.Body>
            </Card>
            <ChangeConfirmation show={show} onClose={() => setShow(false)} info={info} callBk={getData} method="GET" />
            <ModChangeAgentePay show={showt} onClose={() => setShowt(false)} data={item} callBk={getData} />
            <ModEditCorte show={showE} onClose={() => setShowE(false)} data={item} callBk={getData} />

            <Confirmation show={showd} toggle={() => setShowd(false)} data={destroy} info={destroy} callBk={getData} />
        </div>
    );
};

export default CortesTecnicos;
